export class EventType<T = undefined> {
  constructor(
    readonly name: string,
    /**
     * Full documentation is shown in Riveter but not exported to BigQuery.
     * It should be a detailed description of ways to fire the event —
     * think "how would I QA this event?"
     */
    readonly description: string,
  ) {}

  // These cause TypeScript to enforce the type of the properties when we
  // try to log the event
  __covariant!: T;
  __contravariant!: (arg: T) => void;
}

export const EncounterFrownyFaceError = new EventType<{
  'component name': string;
}>(
  'Encounter frowny face error',
  `
  * *encounter a frowny face error* 🙁
  `,
);
export const ViewPage = new EventType(
  'View page',
  `
  * *view any page*
  `,
);
